import { IContact } from 'clickNgo/entities/contact'
import { I379Form } from 'clickNgo/models/crud/forms/i379Form'

export const map379FromContact = (contact: IContact): I379Form => ({
  EntryId: contact.entryId379,
  ChangeMindset: contact.changeMindset,
  Competitors: contact.competitors,
  ContactStatus: contact.contactStatus,
  FacebookLink: contact.facebookLink,
  GDPR: contact.isGDPR ? 1 : 0,
  HPChampion: contact.isHPChampion ? 1 : 0,
  HPHero: contact.isHPHero ? 1 : 0,
  LinkedInLink: contact.linkedInLink,
  Photo: contact.photo,
  PreferredContact: contact.isPreferredContact ? 1 : 0,
  RelationshipStrength: contact.relationshipStrength,
  Role: contact.role,
  TwitterLink: contact.twitterLink,
  WhatsAppLink: contact.whatsAppLink,
  Modified: contact.modified,
  ModifiedBy: contact.modifiedBy,
  ContactID: contact.contactId,
  PartnerID: contact.partnerId,
  AppId: contact.appId,
})
